import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InitSuperAdminForm from "../components/InitSuperAdminForm";
import axiosInstance from "../utils/axiosInstance";
import { Box, Typography, Paper } from "@mui/material";
import Logo1 from "../assets/logo1.png";
import Logo2 from "../assets/logo.png";
import LoginForm from "../components/LoginForm";
import SnackbarAlert from "../components/SnackBarAlert";

const Login = () => {
  const navigate = useNavigate();
  const [isFirstUser, setIsFirstUser] = useState(false);
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // Run once on mount — [feedback] in deps caused an infinite loop:
  // catch sets feedback → triggers re-run → API call fails → catch again → ∞
  useEffect(() => {
    axiosInstance
      .get("api/auth/check-user")
      .then((response) => {
        if (response.data.exists === false) {
          setIsFirstUser(true);
        }
      })
      .catch(() => {
        setFeedback({
          open: true,
          message: "Failed to verify users",
          severity: "error",
        });
      });
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, role, navigate]);

  const handleCloseFeedback = useCallback(() => {
    setFeedback((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Paper
        sx={{
          padding: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: 400,
          backgroundColor: "rgba(255, 255, 255, 0.92)",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <img
          src={Logo1}
          alt="Logo"
          style={{ marginBottom: "20px", width: "100px" }}
        />

        <Typography variant="h5" sx={{ marginBottom: 2 }}>
          {isFirstUser ? "Create First Superadmin" : "Login"}
        </Typography>

        {isFirstUser ? (
          <InitSuperAdminForm
            onSuperadminCreated={() => setIsFirstUser(false)}
          />
        ) : (
          <LoginForm />
        )}
      </Paper>
      <Box
        sx={{
          position: "absolute",
          bottom: 25,
          right: 125,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" sx={{ color: "#F0F0F0" }}>
          Supported by
        </Typography>
        <a
          href="https://vyoobam.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline-block" }}
        >
          <img
            src={Logo2}
            alt="Logo"
            style={{
              width: 80,
              marginBottom: 4,
              cursor: "pointer",
              transition: "transform 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </a>
      </Box>
      {/* onClose (capital C) — lowercase 'onclose' is ignored by React */}
      <SnackbarAlert feedback={feedback} onClose={handleCloseFeedback} />
    </Box>
  );
};

export default Login;
